<script setup lang="ts">
import { useMessenger } from '../composables/useMessenger'

import MessengerWindow from './MessengerWindow.vue'

defineProps<{
  userId: string
}>()

const messenger = useMessenger()
</script>

<template>
  <div class="fixed bottom-0 right-4 z-50 flex items-end gap-4 pointer-events-none">
    <div class="flex items-end gap-4 pointer-events-auto">
      <MessengerWindow
        v-for="chat in messenger.activeChats"
        :key="chat.conversationId"
        v-bind="chat"
        :user-id="userId"
      />
    </div>
  </div>
</template>
